import { useApiCreate } from '../../../../../lib/HttpService';
import { PATH } from './const';
import { StubbornRouter } from '../../../../../application/business/StubbornRouter';

export const useEditionRouterCreate = () => useApiCreate<StubbornRouter>(PATH);
